import loadCSS from './loadCss';
import loadScript from '../../util/loadscript';

export default async function loadComponent(id) {
  const [name, version] = id.split('|');
  const jsUrl = `//g.alicdn.com/dawn/delivery-view/${version}/js/${name}.js`;
  const cssUrl = `//g.alicdn.com/dawn/delivery-view/${version}/css/${name}.css`;
  loadCSS(cssUrl);
  return await loadScript(jsUrl);
}



// WEBPACK FOOTER //
// ./src/components/delivery/loadComponent.js